
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import JsxParser from 'react-jsx-parser'
import {withApollo} from '@apollo/client/react/hoc'
import {KeywordsService} from '../../services/keywordsService'
import Disclosure from '../../disclosure'
import {Rate} from '@cred/react-rate'

class TextDisclosure extends Component {
  static propTypes = {
    variables: PropTypes.object.isRequired,
    disclosure: PropTypes.object.isRequired,
    actions: PropTypes.object,
    client: PropTypes.object
  }

  render() {
    const {disclosure, variables, actions, client} = this.props,
      keywordsService = new KeywordsService(disclosure.htmlContent, disclosure, client),
      renderedContent = keywordsService.renderVariables(variables).renderRates().renderChildren().content

    return <JsxParser bindings={{actions}} components={{Disclosure, Rate}} renderInWrapper={false} jsx={renderedContent}/>
  }
}

export {TextDisclosure as TextDisclosureNoHOCs}

export default withApollo(TextDisclosure)
